import { useOrderMovements } from '@api/useOrderMovements'
import { ErrorNotification } from '@gravitate-js/excalibrr'
import { Form } from 'antd'
import React, { useEffect, useMemo, useState } from 'react'

import { createBolRequest } from '../../../Utils/general'
import { MovementHeader } from '../MovementHeader'
import { BolRow } from './Header/BolRow'
import api from '@utils/api'
import { useModelConfig } from '@hooks/useModelConfig'

export function BolForm({
  orderId,
  detail,
  onBOLSuccess,
  hasBeenSaved,
  editing,
  setEditing,
  editingDrops,
  isBackhaul,
  handleOpenImageModal,
  timezone,
}) {
  const [popConfirmTitle, setPopConfirmTitle] = useState('')

  const { saveBOLMutation } = useOrderMovements()
  const { mutateAsync } = saveBOLMutation()
  const bolKey = hasBeenSaved.bols ? 'bols' : 'prefill_pocket_bols'
  const [saveLoading, setSaveLoading] = useState(false)
  const [form] = Form.useForm()
  const { config } = useModelConfig()
  const backOfficeErp = useMemo(
    () => config?.backoffice_erp_integration?.validation_enabled && config?.backoffice_erp_integration?.file_enabled,
    [config]
  )

  useEffect(() => {
    setEditing(!hasBeenSaved.bols)
    form.setFieldsValue({ ...detail })
  }, [hasBeenSaved.bols])

  const onCancel = () => {
    setEditing(false)
    form.setFieldsValue({ ...form.getFieldsValue(), [bolKey]: detail[bolKey]?.filter((bol) => bol) })
  }

  const saveRequest = async (data) => {
    let formData = data
    setSaveLoading(true)
    if (!formData) formData = form.getFieldsValue()
    const newBOLs = createBolRequest({ ...detail, [bolKey]: formData[bolKey], order_id: orderId }, bolKey, timezone)
    const request = { shouldRefresh: hasBeenSaved.drops && !editingDrops, bols: newBOLs }
    try {
      const data = await mutateAsync(request)
      onBOLSuccess(data.orders?.[0])
      setEditing(false)
    } catch (error) {
      ErrorNotification(error)
    } finally {
      setSaveLoading(false)
    }
  }
  const checkStatus = async (formData) => {
    if (!backOfficeErp) {
      await saveRequest(formData)
    } else {
      try {
        const hasBeenExported = await api.checkExportStatus({ order_id: orderId })
        if (hasBeenExported.data === true) {
          setPopConfirmTitle('This order has been exported. Are you sure you want to continue?')
        } else {
          await saveRequest(formData)
        }
      } catch (error) {
        ErrorNotification({
          errorFields: [
            {
              errors: [`Failed to fetch export status.`],
            },
          ],
        })
      }
    }
  }

  return (
    <Form form={form} size='small' onFinish={(formData) => checkStatus(formData)} onFinishFailed={ErrorNotification}>
      <Form.List name={bolKey}>
        {(fields, { add, remove }) => {
          return (
            <>
              <MovementHeader
                title='BOLs'
                editing={editing}
                setEditing={setEditing}
                addItem={() =>
                  add({
                    number: null,
                    type: null,
                    location: null,
                    date: null,
                    details: [
                      {
                        supplier: null,
                        product: null,
                        contract: null,
                        net: null,
                        gross: null,
                        compartment_index: null,
                      },
                    ],
                  })
                }
                allowCancel={hasBeenSaved.bols}
                onCancel={onCancel}
                saveLoading={saveLoading}
                popConfirmTitle={popConfirmTitle}
                setPopConfirmTitle={setPopConfirmTitle}
                saveRequest={saveRequest}
                form={form}
                handleOpenImageModal={handleOpenImageModal}
                detail={detail}
              />
              {fields.map((field, index) => (
                <BolRow
                  orderId={orderId}
                  isBackhaul={isBackhaul}
                  key={index}
                  index={index}
                  field={field}
                  fields={fields}
                  bol={detail[bolKey][index]}
                  attendantNote={detail?.attendant_note}
                  editing={editing}
                  removeBOL={() => remove(index)}
                  handleOpenImageModal={handleOpenImageModal}
                  timezone={timezone}
                />
              ))}
            </>
          )
        }}
      </Form.List>
    </Form>
  )
}
